"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GardenConnector_gql;
Object.defineProperty(exports, "__esModule", { value: true });
exports.pollIntervalFromChainId = exports.subgraphUrlFromChainId = void 0;
const connect_thegraph_1 = require("@1hive/connect-thegraph");
const queries = __importStar(require("./queries"));
const parsers_1 = require("./parsers");
const BLOCK_TIMES = new Map([
    [1, 13],
    [4, 14],
    [100, 5],
    [137, 2],
    [80001, 2], // mumbai
]);
function subgraphUrlFromChainId(chainId) {
    if (chainId === 1) {
        return 'https://api.thegraph.com/subgraphs/name/1hive/gardens-mainnet';
    }
    if (chainId === 4) {
        return 'https://api.thegraph.com/subgraphs/name/1hive/gardens-rinkeby';
    }
    if (chainId === 100) {
        return 'https://api.thegraph.com/subgraphs/name/1hive/gardens-xdai';
    }
    if (chainId === 137) {
        return 'https://api.thegraph.com/subgraphs/name/1hive/gardens-polygon';
    }
    if (chainId === 80001) {
        return 'https://api.thegraph.com/subgraphs/name/1hive/gardens-mumbai';
    }
    return null;
}
exports.subgraphUrlFromChainId = subgraphUrlFromChainId;
function pollIntervalFromChainId(chainId) {
    const blockTime = BLOCK_TIMES.get(chainId);
    return blockTime ? blockTime * 1000 : null;
}
exports.pollIntervalFromChainId = pollIntervalFromChainId;
/**
 * Connector that expose functionalities to fetch garden data from subgraphs.
 * @category Utility
 */
class GardenConnector {
    /**
     * Create a new GardenConnector instance.z
     * @param config The connector configuration object.
     */
    constructor(config) {
        _GardenConnector_gql.set(this, void 0);
        if (!config.subgraphUrl) {
            throw new Error('Garden connector requires subgraphUrl to be passed.');
        }
        __classPrivateFieldSet(this, _GardenConnector_gql, new connect_thegraph_1.GraphQLWrapper(config.subgraphUrl, {
            pollInterval: config.pollInterval,
            verbose: config.verbose,
        }), "f");
    }
    /**
     * Close the connection.
     */
    async disconnect() {
        __classPrivateFieldGet(this, _GardenConnector_gql, "f").close();
    }
    /**
     * Fetch the configuration of the garden.
     * @param address The address of the garden to fetch.
     * @returns A promise that resolves to the configuratio of the garden.
     */
    async config(address) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").performQueryWithParser(queries.CONFIG('query'), { address }, (result) => (0, parsers_1.parseConfig)(result, this));
    }
    /**
     * Subscribe to updates in the configuration of the garden.
     * @param address The address of the garden to subscribe.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to the configuratio of the garden.
     */
    onConfig(address, callback) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").subscribeToQueryWithParser(queries.CONFIG('subscription'), { address }, callback, (result) => (0, parsers_1.parseConfig)(result, this));
    }
    /**
     * Fetch a proposal of the garden.
     * @param id The identifier of the proposal to fetch.
     * @returns A promise that resolves to a proposal of the garden.
     */
    async proposal(id) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").performQueryWithParser(queries.PROPOSAL('query'), { id }, (result) => (0, parsers_1.parseProposal)(result, this));
    }
    /**
     * Subscribe to updates in a proposal of the garden.
     * @param id The identifier of the proposal to subscribe.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to a proposal of the garden.
     */
    onProposal(id, callback) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").subscribeToQueryWithParser(queries.PROPOSAL('subscription'), { id }, callback, (result) => (0, parsers_1.parseProposal)(result, this));
    }
    /**
     * Fetch a list of proposals of the garden.
     * @param garden The address of the garden to fetch.
     * @param first Number of entities to return.
     * @param skip Number of entities to skip.
     * @param orderBy Filter to order the results.
     * @param orderDirection Direction to order the results.
     * @param types Filter by proposal type.
     * @param statuses Filter by proposal status.
     * @param metadata Filter by proposal name.
     * @returns A promise that resolves to a list of proposals of the garden.
     */
    async proposals(garden, first, skip, orderBy, orderDirection, types, statuses, metadata) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").performQueryWithParser(queries.ALL_PROPOSALS('query'), {
            garden,
            first,
            skip,
            orderBy,
            orderDirection,
            proposalTypes: types,
            statuses,
            metadata,
        }, (result) => (0, parsers_1.parseProposals)(result, this));
    }
    /**
     * Subscribe to updates of a list of proposals of the garden.
     * @param garden The address of the garden to subscribe.
     * @param first Number of entities to return.
     * @param skip Number of entities to skip.
     * @param orderBy Filter to order the results.
     * @param orderDirection Direction to order the results.
     * @param types Filter by proposal types.
     * @param statuses Filter by proposal statuses.
     * @param metadata Filter by proposal name.
     * @returns A GraphQL subsription to a list of proposals of the garden.
     */
    onProposals(garden, first, skip, orderBy, orderDirection, types, statuses, metadata, callback) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").subscribeToQueryWithParser(queries.ALL_PROPOSALS('subscription'), {
            garden,
            first,
            skip,
            orderBy,
            orderDirection,
            proposalTypes: types,
            statuses,
            metadata,
        }, callback, (result) => (0, parsers_1.parseProposals)(result, this));
    }
    /**
     * Fetch a supporter of the garden.
     * @param id The identifier of the supporter to fetch.
     * @returns A promise that resolves to a supporter of the garden.
     */
    async supporter(id) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").performQueryWithParser(queries.SUPPORTER('query'), { id }, (result) => (0, parsers_1.parseSupporter)(result, this));
    }
    /**
     * Subscribe to updates in a supporter of the garden.
     * @param id The identifier of the supporter to fetch.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to a supporter of the garden.
     */
    onSupporter(id, callback) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").subscribeToQueryWithParser(queries.SUPPORTER('subscription'), { id }, callback, (result) => (0, parsers_1.parseSupporter)(result, this));
    }
    /**
     * Fetch the collateral requirement of a proposal of the garden.
     * @param proposalId The identifier of the proposal.
     * @returns A promise that resolves to the collateral requirement of a proposal.
     */
    async collateralRequirement(proposalId) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").performQueryWithParser(queries.COLLATERAL_REQUIREMENT('query'), { proposalId }, (result) => (0, parsers_1.parseCollateralRequirement)(result, this));
    }
    /**
     * Subscribe to updates in the collateral requirement of a proposal of the garden.
     * @param proposalId The identifier of the proposal.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to the collateral requirement of a proposal.
     */
    onCollateralRequirement(proposalId, callback) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").subscribeToQueryWithParser(queries.COLLATERAL_REQUIREMENT('subscription'), { proposalId }, callback, (result) => (0, parsers_1.parseCollateralRequirement)(result, this));
    }
    /**
     * Fetch the arbitrator fee of a proposal of the garden.
     * @param arbitratorFeeId The identifier of the arbitrator fee.
     * @returns A promise that resolves to the arbitrator fee of a proposal.
     */
    async arbitratorFee(arbitratorFeeId) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").performQueryWithParser(queries.ARBITRATOR_FEE('query'), { arbitratorFeeId }, (result) => (0, parsers_1.parseArbitratorFee)(result, this));
    }
    /**
     * Subscribe to updates in the arbitrator fee of a proposal of the garden.
     * @param arbitratorFeeId The identifier of the arbitrator fee.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to the arbitrator fee of a proposal.
     */
    onArbitratorFee(arbitratorFeeId, callback) {
        return __classPrivateFieldGet(this, _GardenConnector_gql, "f").subscribeToQueryWithParser(queries.ARBITRATOR_FEE('subscription'), { arbitratorFeeId }, callback, (result) => (0, parsers_1.parseArbitratorFee)(result, this));
    }
}
exports.default = GardenConnector;
_GardenConnector_gql = new WeakMap();
